import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  instructions: {
    fontWeight: tokens.fontWeightSemibold,
    marginBottom: "10px",
    textAlign: "center",
    paddingTop: "40px",
    paddingBottom: "20px",
  },
  buttonGroup: {
    display: "flex",
    gap: "10px",
    marginTop: "20px",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "20px",
  },
});
